<template>
  <div class='mt-4'>
    <span class="text-sm uppercase text-gray-500 tracking-wider leading-4">
      {{ title }}
    </span>
    <vue-editor v-model="element.text" :editorToolbar="toolbarOptions"></vue-editor>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";

export default {
  components: {
    VueEditor
  },

  props: {
    element: {
      type: Object,
      default: () => {
        return {};
      },
    },
     title: {
      type: String,
      default: 'TEXT'
    }
  },

  data() {
    return {
      toolbarOptions: [
        [{ font: [] }],
        [{ header: [1, 2, 3, 4, 5, 6] }],
        [{ 'size': ['10px', '12px', '14px', '16px', '18px', '20px', '24px', '30px', '32px', '36px'] }],
        ["bold"],
        ["italic"],
        ["underline"],
        ["strike"], //, toggled buttons
        ["blockquote"],
        ["code-block"],
        [{ list: "ordered" }],
        [{ list: "bullet" }], // superscript/subscript
        [{ align: [] }],
        ['link'],
        ["clean"], // remove formatting button
        [{ 'color': [] }],
      ],
    };
  },

  watch: {},

  methods: {},

  computed: {},

  mounted() {
  },
};
</script>

